'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "days" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/days.js
// module id = 849
// module chunks = 0